import type { MotorP } from "../../tip";

/** ISO günü (2026-01-05) → 05.01.2026; motorun eski yazımı. */
const gun = (iso: string | undefined): string =>
  iso === undefined || iso.length < 10 ? String(iso) : `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}`;

/**
 * Türkçe sözlük · motor mesajları · sanal. Anahtar motorun `mm("kod", …)`
 * çağrısındaki koddur; değer, mesajın değerlerinden cümleyi kurar.
 */
export const sanal = {
  "sanal.cekimKarsilanamadi": (p: MotorP) =>
    `Çekim tam karşılanamadı: istenen ${p.istenen} ${p.para}, çekilen ${p.cekilen} ${p.para} (satılabilecek varlık kalmadı).`,
  "sanal.temettuParaBirimiBilinmiyor": (p: MotorP) => `${p.varlik} temettüsünün para birimi bilinmiyor; hesaba girmedi.`,
  "sanal.paraGirisiYok": () => "Seçilen hesaplarda bu aralıkta para girişi ya da alış yok.",
  "sanal.temettuBilgisiYok": (p: MotorP) => `${p.varlik} için temettü bilgisi yok; temettü hesaba girmedi.`,
  "sanal.temettuKapsami": (p: MotorP) =>
    `${p.varlik} temettü bilgisi yalnızca ${gun(p.from)}–${gun(p.to)} için var; dışındaki temettüler hesaba girmedi.`,
  "sanal.temettuTutariYok": (p: MotorP) => `${p.varlik} temettüsünün tutarı kaynakta yok; hesaba girmedi.`,
  "sanal.payYetmediNakitte": (p: MotorP) =>
    `${p.varlik}: ${p.sayi} alımda ayrılan pay (komisyon dahil) alıma yetmedi; para nakitte bekledi.`,
  "sanal.payYetmediKusurata": (p: MotorP) =>
    `${p.varlik}: ${p.sayi} alımda ayrılan pay (komisyon dahil) alıma yetmedi; para küsuratlı alınan varlığa geçti.`,
  "sanal.islemGunuGelmedi": () => "Bu tarihe kadar işlem günü gelmedi; hareket yok.",
  // üretimi durduran sebepler (SanalHareketDokumu.hata)
  "sanal.durdurKurYok": (p: MotorP) => `${gun(p.tarih)} için ${p.base}/${p.quote} kuru yok.`,
  "sanal.durdurKaynaktaFiyatYok": (p: MotorP) =>
    `${p.varlik} için ${gun(p.tarih)} ve öncesinde kaynakta fiyat yok; başlangıç bu varlığın ilk fiyat gününden önce olamaz.`,
  "sanal.durdurFiyatIndirilmedi": (p: MotorP) => `${p.varlik} için ${gun(p.tarih)} fiyatı henüz indirilmedi.`,
  "sanal.durdurParaBirimiBilinmiyor": (p: MotorP) => `${p.varlik}: para birimi bilinmiyor.`,
  "sanal.durdurFiyatSifir": (p: MotorP) => `${p.varlik}: ${gun(p.tarih)} fiyatı sıfır.`,
} satisfies Record<string, (p: MotorP) => string>;
